module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Light.woff?v=5bc579e652cdd492d0285d85150559d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Light.woff
// module id = 655
// module chunks = 0